import React, { useState } from 'react';
import TextInput from '../FormInputs/TextInput/TextInput';
import Button from '../Button/Button';
import HypertextLink from '../HypertextLink/HypertextLink';
import { useToasts } from '../../hooks/useToasts';
import { requestPasswordReset } from '../../utils/api/passwordReset';

const ResetPasswordRequestForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const { showToast } = useToasts();

  const handleSubmit = async () => {
    setError('');
    if (!email) {
      const message = 'Email is required.';
      setError(message);
      showToast({ message, type: 'error' });
      return;
    }
    try {
      const result = await requestPasswordReset(email);

      if (result.success) {
        if (result.data.confirmed) {
          window.location.href = '/users/password/requested';
        } else {
          showToast({ message: result.data.message, type: 'info' });
        }
      } else {
        setError(result.error);
        showToast({ message: result.error, type: 'error' });
      }
    } catch (err) {
      showToast({ message: 'Failed to send reset email. Please try again later.', type: 'error' });
    }
  };

  return (
    <div className="w-77 min-h-83.5">
      <h3 className="text-2xl font-bold text-center mb-6">Forgot password?</h3>

      <TextInput
        label="Email"
        name="email"
        dataTestId="reset-password-email-input"
        value={email}
        setValue={setEmail}
        placeholder="example@email.com"
        isRequired
        className="h-10 pt-3.25 pb-3.25 pl-3 mb-4.75"
        labelTextSize="text-lg font-medium"
        error={error}
        spaceY="space-y-1"
        fontSize="text-sm"
      />

      <div className="flex justify-center items-center">
        <Button
          label="Send reset email"
          type="button"
          dataTestId="reset-password-send-button"
          onClick={handleSubmit}
          className="inline-flex h-9.5 min-w-20.5 mt-3.25 justify-center items-center flex-shrink-0"
          fontWeight="font-medium"
        />
      </div>

      <div className="text-center mt-4">
        <HypertextLink href="/users/password/resend_email">
          Didn’t receive email?
        </HypertextLink>
      </div>

      <div className="text-center">
        <HypertextLink href="/users/sign_in">Back to Login</HypertextLink>
      </div>
    </div>
  );
};

export default ResetPasswordRequestForm;
